import Component from '@glimmer/component';
import { service } from '@ember/service';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import Scopes from '@linc-technologies/linced-common/enums/scopes';

export default class BannerActions extends Component {
  @service features;

  PersonType = PersonType;
  Scopes = Scopes;
}
